function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.18 142.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M94.18,30.13s-.06,.03-.09,.02c0,0,0,0-.01,0-.01,0-.03-.02-.04-.03-.17-.77-.17-1.55-.28-2.33-.42-3.29-1.27-6.46-2.59-9.5-1.32-3.06-2.96-5.92-5.15-8.44-2.16-2.49-4.68-4.52-7.55-6.12-2.74-1.52-5.65-2.56-8.74-3.09-.77-.13-1.55-.25-2.33-.3-.32-.02-.64-.05-.95-.19-.02-.01-.03-.03-.03-.05h.02c4.33,.29,8.41,1.44,12.2,3.56,1.97,1.11,3.77,2.43,5.43,3.97,1.56,1.45,2.92,3.06,4.11,4.81,1.12,1.64,2.05,3.39,2.86,5.19,.98,2.17,1.74,4.4,2.25,6.73,.31,1.4,.55,2.8,.69,4.23,.05,.51,.07,1.02,.1,1.53,.03,0,.06,0,.09,0Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66,.11s-.02,.03-.03,.05c-.67,.21-1.38,.2-2.07,.28-4.63,.57-8.83,2.23-12.65,4.9-1.25,.88-2.43,1.84-3.48,2.92-1.74,1.79-3.28,3.74-4.6,5.86-2.37,3.82-3.8,7.96-4.36,12.41-.06,.49-.12,.98-.17,1.47-.01,.02-.02,.04-.03,.06-.05,.16,.01,.36-.08,.51-.04,.05-.09,.1-.19,.12,.12-.09,.09-.23,.1-.36,0-.13-.02-.26,.1-.36,.22-2.9,.82-5.73,1.83-8.46,1.09-2.95,2.64-5.65,4.54-8.15,.86-1.13,1.77-2.21,2.78-3.21,1.8-1.78,3.81-3.29,6.03-4.53,2.66-1.49,5.48-2.51,8.46-3.07,1.25-.24,2.52-.38,3.8-.45h.02Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,142.08H24.47c-.03-.07,0-.13,.06-.17,.24-.12,.5-.1,.75-.1,14.61,0,29.22,0,43.82,0,.25,0,.51-.03,.75,.1,.07,.04,.09,.1,.06,.17Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.63,.11s0-.06,0-.09h38.29c.03,.07,0,.13-.06,.17-.24,.12-.5,.1-.75,.1-12.22,0-24.44,0-36.65,0-.28,0-.59,.06-.82-.17Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.34,32.13c.03,.3,.1,.61-.14,.87-.11-.1-.09-.24-.09-.36,0-.13,.02-.26-.1-.36v-3.58c.12-.09,.09-.23,.1-.36,0-.13-.02-.26,.1-.36,.03,.03,.05,.06,.07,.09,.15,.24,.09,.51,.07,.78-.11,1.1-.11,2.19,0,3.29Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.18,34.12s-.06,0-.09,0c-.13-.1-.16-.26-.16-.41-.02-.91-.02-1.82,0-2.73,0-.1,.03-.2,.08-.29,.04-.07,.1-.09,.17-.06v3.48Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.46,141.98s0,.06,0,.1h-.82s0-.06,0-.09c.27-.21,.54-.21,.82,0Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,142.08s0-.06,0-.1c.24-.19,.48-.19,.71,0,0,.03,0,.06,0,.09h-.72Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,.1s0-.06,0-.09h.51s0,.06,0,.09c-.17,.15-.34,.15-.51,0Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.18,30.13v.51s-.06,0-.09,0c0,0,0,0,0,0-.15-.16-.15-.33,0-.49,0,0,0-.01,.01-.02,.03,0,.06,0,.09,0Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,17.03c.06,3.56-2.94,6.66-6.68,6.62-3.69-.03-6.61-2.95-6.61-6.66,0-3.91,3.24-6.69,6.73-6.65,3.68,.04,6.66,3.13,6.57,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,7.93c-5.17-.02-9.03,4.19-9.1,8.99-.07,4.98,4.18,9.27,9.03,9.12,4.76,.14,9.03-3.78,9.1-8.91,.07-5.07-3.92-9.18-9.03-9.21Zm-.03,16.73c-4.6-.02-7.64-3.8-7.64-7.65,0-4.03,3.27-7.68,7.68-7.66,4.27,.03,7.63,3.47,7.62,7.67,0,4.11-3.3,7.65-7.66,7.63Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,33.91c-.01,3.42-2.73,6.66-6.69,6.64-3.82-.02-6.63-3.07-6.63-6.69,0-3.65,3.09-6.67,6.66-6.6,3.58-.06,6.66,2.96,6.65,6.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46,24.82c-5.27-.02-9.21,4.33-9.08,9.08-.13,4.95,4.15,9.04,8.94,9.06,4.96,.03,9.16-3.95,9.16-9.03,0-5.11-4.06-9.1-9.02-9.12Zm-.05,16.7c-3.93,.1-7.69-3.13-7.66-7.66,.03-4.4,3.57-7.61,7.68-7.62,4.19,0,7.65,3.47,7.63,7.67-.01,4.34-3.62,7.71-7.66,7.61Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,17.04c-.01,3.51-2.87,6.65-6.72,6.61-3.63-.03-6.59-2.95-6.58-6.69,0-3.72,3.13-6.66,6.67-6.6,3.65-.01,6.64,2.98,6.63,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02,7.93c-5.25-.02-9.04,4.37-9.07,9.02-.03,4.97,4.17,9.22,9.01,9.09,4.82,.14,9.14-3.81,9.12-9.03-.01-5.17-4.07-9.06-9.06-9.08Zm-.03,16.73c-4.35-.02-7.62-3.4-7.62-7.66,0-4.36,3.47-7.61,7.65-7.65,4.25,.04,7.65,3.4,7.65,7.65,0,4.21-3.28,7.69-7.67,7.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.09,30.15v-.02c-.03-.51-.05-1.02-.1-1.53-.14-1.43-.38-2.83-.69-4.23-.51-2.32-1.28-4.56-2.25-6.73-.81-1.81-1.74-3.56-2.86-5.19-1.19-1.75-2.55-3.36-4.11-4.81-1.66-1.54-3.47-2.87-5.43-3.97-3.79-2.13-7.87-3.28-12.2-3.56h-.02c-.16,0-.33,0-.49,0-.15,0-.31,0-.46,0-12.27,0-24.54,0-36.81,0-.33,0-.67,0-1,0h-.02c-1.28,.07-2.55,.21-3.8,.45-2.99,.57-5.81,1.59-8.46,3.07-2.22,1.24-4.23,2.75-6.03,4.53-1.01,1-1.92,2.08-2.78,3.21-1.9,2.5-3.44,5.2-4.54,8.15-1.01,2.73-1.61,5.55-1.83,8.46,0,.2,0,.4,0,.6-.02,.75-.1,1.5-.09,2.25,0,.73,.17,1.45,.1,2.18,.1,1.39,.28,2.78,.52,4.15,.53,2.98,1.37,5.87,2.44,8.69,1.28,3.37,2.83,6.61,4.65,9.73,1.99,3.42,4.11,6.76,6.66,9.8,1.46,1.73,3.06,3.3,4.8,4.74,1.83,1.51,3.78,2.85,5.86,4,2.77,1.53,5.68,2.74,8.74,3.56,1.94,.52,3.91,.89,5.91,1.14,1.62,.2,3.25,.38,4.88,.39,1.76,0,3.51,.05,5.27-.09,1.22-.09,2.45-.19,3.66-.36,1.99-.27,3.96-.64,5.92-1.1,2.88-.68,5.69-1.53,8.38-2.77,3.73-1.72,7.12-3.96,10.14-6.73,2.16-1.98,4.08-4.17,5.73-6.59,2.31-3.39,4.37-6.92,6.06-10.66,1.36-2.99,2.46-6.06,3.22-9.25,.59-2.47,1.02-4.97,1.07-7.52,0-1.17,0-2.33,0-3.49h0c0-.17,0-.33,0-.49Zm-4.53,2.87c-.03,2.17-.31,4.31-.76,6.43-.73,3.48-1.91,6.82-3.42,10.04-1.87,3.98-4.09,7.75-6.76,11.24-1.34,1.75-2.88,3.32-4.55,4.76-2.29,1.97-4.79,3.6-7.5,4.92-2.43,1.18-4.98,2.02-7.61,2.64-2,.48-4.02,.88-6.06,1.14-1.05,.13-2.09,.24-3.15,.32-1.27,.09-2.55,.18-3.83,.14-1.43-.04-2.86-.09-4.28-.24-2.2-.24-4.39-.59-6.52-1.16-2.63-.7-5.14-1.71-7.52-3.02-1.69-.93-3.3-1.99-4.81-3.19-1.69-1.34-3.24-2.81-4.65-4.44-2.18-2.53-3.95-5.34-5.69-8.18-1.27-2.07-2.38-4.22-3.4-6.42-1.37-2.92-2.48-5.94-3.25-9.08-.41-1.67-.71-3.36-.9-5.07-.18-1.62-.24-3.23-.16-4.85,.16-3.08,.81-6.07,2.03-8.92,1.18-2.75,2.79-5.22,4.75-7.48,1.85-2.12,4.01-3.83,6.49-5.16,2.43-1.3,5-2.13,7.73-2.53,1.1-.16,2.2-.2,3.31-.2,5.97,0,11.94,0,17.91,0,5.97,0,11.94,.02,17.91,0,4.01-.02,7.75,.95,11.27,2.84,1.52,.82,2.92,1.81,4.23,2.95,2.18,1.89,3.9,4.12,5.29,6.64,1.41,2.57,2.48,5.27,3.13,8.13,.36,1.56,.59,3.14,.71,4.74,.07,1.01,.09,2.01,.07,3.02Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.53,115.37c.53,3.4-.25,6.52-2.35,9.25-2.18,2.82-5.07,4.5-8.59,5.08-1.03,.17-2.07,.24-3.1,.17-2.97-.21-5.64-1.19-7.96-3.11-1.82-1.51-3.13-3.36-3.91-5.58-.47-1.36-.71-2.78-.66-4.22,.11-2.68,.98-5.1,2.67-7.21,2.08-2.6,4.79-4.16,8.03-4.81,.87-.17,1.75-.28,2.36-.25,3.54,0,6.48,1,9.02,3.06,2.43,1.97,3.99,4.52,4.48,7.63Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,114.7c.19,.85,.31,1.71,.28,2.59-.03,3.11-1.08,5.83-3.16,8.14-2.05,2.28-4.6,3.69-7.59,4.21-4.21,.74-8.05-.18-11.41-2.9-1.82-1.48-3.11-3.33-3.88-5.54-.34-.98-.53-2-.61-3.04-.19-2.37,.32-4.57,1.44-6.64,1.13-2.09,2.76-3.7,4.8-4.92,1.57-.94,3.27-1.54,5.08-1.77,3.84-.5,7.35,.35,10.45,2.72,2.39,1.83,3.94,4.21,4.61,7.15Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.17,113.8c-.34-2.59-1.11-5.06-2.25-7.4-1.28-2.63-2.99-4.95-5.1-6.98-1.68-1.62-3.55-2.98-5.61-4.07-3.66-1.93-7.56-2.86-11.69-2.86-14.25,0-28.49,0-42.74,0-1.33,0-2.65,.1-3.97,.3-2.41,.36-4.71,1.08-6.9,2.14-1.94,.94-3.74,2.11-5.37,3.52-1.75,1.52-3.3,3.21-4.57,5.15-1.39,2.12-2.46,4.4-3.15,6.85-.45,1.58-.77,3.18-.87,4.81-.07,1.03-.15,2.07-.06,3.11,.08,.92,.12,1.84,.26,2.74,.5,3.11,1.54,6.04,3.15,8.75,1.63,2.74,3.71,5.09,6.23,7.04,1.97,1.52,4.13,2.71,6.46,3.58,2.15,.81,4.37,1.28,6.66,1.48,.27,0,.54,0,.82,0,.12,0,.24,0,.36,0,14.7,0,29.39,0,44.09,0,.34,0,.68,0,1.02,0,.24,0,.48,0,.71,0,.67-.08,1.36-.13,2.03-.24,2.71-.47,5.28-1.32,7.7-2.62,1.75-.95,3.37-2.07,4.84-3.4,1.95-1.76,3.59-3.78,4.91-6.06,2.17-3.76,3.23-7.82,3.33-12.14,.03-1.24-.1-2.48-.27-3.72Zm-4.33,3.74c-.07,2.65-.57,5.21-1.62,7.65-.9,2.08-2.11,3.97-3.64,5.65-2.58,2.83-5.7,4.78-9.38,5.84-1.28,.37-2.58,.59-3.91,.71-.75,.07-1.5,.07-2.24,.07-14.09,0-28.18,0-42.27,0-3.38,0-6.58-.76-9.57-2.34-1.48-.79-2.84-1.75-4.09-2.87-1.93-1.73-3.45-3.76-4.6-6.08-1-2.03-1.65-4.18-1.9-6.44-.1-.91-.2-1.83-.17-2.75,.1-3.63,1.03-7.03,2.92-10.15,.97-1.6,2.14-3.04,3.5-4.31,1.24-1.16,2.6-2.14,4.09-2.96,1.81-.99,3.72-1.69,5.74-2.09,1.34-.26,2.69-.38,4.06-.38,7.15,0,14.29,0,21.44,0s14.26,0,21.39,0c1.73,0,3.43,.19,5.1,.63,2.78,.72,5.28,1.98,7.53,3.76,2.57,2.04,4.52,4.58,5.87,7.56,.72,1.59,1.22,3.25,1.48,4.98,.17,1.17,.31,2.33,.28,3.51Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,17.03c.06,3.56-2.94,6.66-6.68,6.62-3.69-.03-6.61-2.95-6.61-6.66,0-3.91,3.24-6.69,6.73-6.65,3.68,.04,6.66,3.13,6.57,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,7.93c-5.17-.02-9.03,4.19-9.1,8.99-.07,4.98,4.18,9.27,9.03,9.12,4.76,.14,9.03-3.78,9.1-8.91,.07-5.07-3.92-9.18-9.03-9.21Zm-.03,16.73c-4.6-.02-7.64-3.8-7.64-7.65,0-4.03,3.27-7.68,7.68-7.66,4.27,.03,7.63,3.47,7.62,7.67,0,4.11-3.3,7.65-7.66,7.63Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,33.91c-.01,3.42-2.73,6.66-6.69,6.64-3.82-.02-6.63-3.07-6.63-6.69,0-3.65,3.09-6.67,6.66-6.6,3.58-.06,6.66,2.96,6.65,6.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46,24.82c-5.27-.02-9.21,4.33-9.08,9.08-.13,4.95,4.15,9.04,8.94,9.06,4.96,.03,9.16-3.95,9.16-9.03,0-5.11-4.06-9.1-9.02-9.12Zm-.05,16.7c-3.93,.1-7.69-3.13-7.66-7.66,.03-4.4,3.57-7.61,7.68-7.62,4.19,0,7.65,3.47,7.63,7.67-.01,4.34-3.62,7.71-7.66,7.61Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,17.04c-.01,3.51-2.87,6.65-6.72,6.61-3.63-.03-6.59-2.95-6.58-6.69,0-3.72,3.13-6.66,6.67-6.6,3.65-.01,6.64,2.98,6.63,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02,7.93c-5.25-.02-9.04,4.37-9.07,9.02-.03,4.97,4.17,9.22,9.01,9.09,4.82,.14,9.14-3.81,9.12-9.03-.01-5.17-4.07-9.06-9.06-9.08Zm-.03,16.73c-4.35-.02-7.62-3.4-7.62-7.66,0-4.36,3.47-7.61,7.65-7.65,4.25,.04,7.65,3.4,7.65,7.65,0,4.21-3.28,7.69-7.67,7.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.53,115.37c.53,3.4-.25,6.52-2.35,9.25-2.18,2.82-5.07,4.5-8.59,5.08-1.03,.17-2.07,.24-3.1,.17-2.97-.21-5.64-1.19-7.96-3.11-1.82-1.51-3.13-3.36-3.91-5.58-.47-1.36-.71-2.78-.66-4.22,.11-2.68,.98-5.1,2.67-7.21,2.08-2.6,4.79-4.16,8.03-4.81,.87-.17,1.75-.28,2.36-.25,3.54,0,6.48,1,9.02,3.06,2.43,1.97,3.99,4.52,4.48,7.63Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,117.29c-.03,3.11-1.08,5.83-3.16,8.14-2.05,2.28-4.6,3.69-7.59,4.21-4.21,.74-8.05-.18-11.41-2.9-1.82-1.48-3.11-3.33-3.88-5.54-.34-.98-.53-2-.61-3.04-.19-2.37,.32-4.57,1.44-6.64,1.13-2.09,2.76-3.7,4.8-4.92,1.57-.94,3.27-1.54,5.08-1.77,3.84-.5,7.35,.35,10.45,2.72,2.39,1.83,3.94,4.21,4.61,7.15,.19,.85,.31,1.71,.28,2.59Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,33.91c-.01,3.42-2.73,6.66-6.69,6.64-3.82-.02-6.63-3.07-6.63-6.69,0-3.65,3.09-6.67,6.66-6.6,3.58-.06,6.66,2.96,6.65,6.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46,24.82c-5.27-.02-9.21,4.33-9.08,9.08-.13,4.95,4.15,9.04,8.94,9.06,4.96,.03,9.16-3.95,9.16-9.03,0-5.11-4.06-9.1-9.02-9.12Zm-.05,16.7c-3.93,.1-7.69-3.13-7.66-7.66,.03-4.4,3.57-7.61,7.68-7.62,4.19,0,7.65,3.47,7.63,7.67-.01,4.34-3.62,7.71-7.66,7.61Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,17.04c-.01,3.51-2.87,6.65-6.72,6.61-3.63-.03-6.59-2.95-6.58-6.69,0-3.72,3.13-6.66,6.67-6.6,3.65-.01,6.64,2.98,6.63,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02,7.93c-5.25-.02-9.04,4.37-9.07,9.02-.03,4.97,4.17,9.22,9.01,9.09,4.82,.14,9.14-3.81,9.12-9.03-.01-5.17-4.07-9.06-9.06-9.08Zm-.03,16.73c-4.35-.02-7.62-3.4-7.62-7.66,0-4.36,3.47-7.61,7.65-7.65,4.25,.04,7.65,3.4,7.65,7.65,0,4.21-3.28,7.69-7.67,7.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,17.03c.06,3.56-2.94,6.66-6.68,6.62-3.69-.03-6.61-2.95-6.61-6.66,0-3.91,3.24-6.69,6.73-6.65,3.68,.04,6.66,3.13,6.57,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,7.93c-5.17-.02-9.03,4.19-9.1,8.99-.07,4.98,4.18,9.27,9.03,9.12,4.76,.14,9.03-3.78,9.1-8.91,.07-5.07-3.92-9.18-9.03-9.21Zm-.03,16.73c-4.6-.02-7.64-3.8-7.64-7.65,0-4.03,3.27-7.68,7.68-7.66,4.27,.03,7.63,3.47,7.62,7.67,0,4.11-3.3,7.65-7.66,7.63Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18,124.62c-2.18,2.82-5.07,4.5-8.59,5.08-1.03,.17-2.07,.24-3.1,.17-2.97-.21-5.64-1.19-7.96-3.11-1.82-1.51-3.13-3.36-3.91-5.58-.47-1.36-.71-2.78-.66-4.22,.11-2.68,.98-5.1,2.67-7.21,2.08-2.6,4.79-4.16,8.03-4.81,.87-.17,1.75-.28,2.36-.25,3.54,0,6.48,1,9.02,3.06,2.43,1.97,3.99,4.52,4.48,7.63,.53,3.4-.25,6.52-2.35,9.25Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,117.29c-.03,3.11-1.08,5.83-3.16,8.14-2.05,2.28-4.6,3.69-7.59,4.21-4.21,.74-8.05-.18-11.41-2.9-1.82-1.48-3.11-3.33-3.88-5.54-.34-.98-.53-2-.61-3.04-.19-2.37,.32-4.57,1.44-6.64,1.13-2.09,2.76-3.7,4.8-4.92,1.57-.94,3.27-1.54,5.08-1.77,3.84-.5,7.35,.35,10.45,2.72,2.39,1.83,3.94,4.21,4.61,7.15,.19,.85,.31,1.71,.28,2.59Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,33.91c-.01,3.42-2.73,6.66-6.69,6.64-3.82-.02-6.63-3.07-6.63-6.69,0-3.65,3.09-6.67,6.66-6.6,3.58-.06,6.66,2.96,6.65,6.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,17.04c-.01,3.51-2.87,6.65-6.72,6.61-3.63-.03-6.59-2.95-6.58-6.69,0-3.72,3.13-6.66,6.67-6.6,3.65-.01,6.64,2.98,6.63,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,17.03c.06,3.56-2.94,6.66-6.68,6.62-3.69-.03-6.61-2.95-6.61-6.66,0-3.91,3.24-6.69,6.73-6.65,3.68,.04,6.66,3.13,6.57,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,33.91c-.01,3.42-2.73,6.66-6.69,6.64-3.82-.02-6.63-3.07-6.63-6.69,0-3.65,3.09-6.67,6.66-6.6,3.58-.06,6.66,2.96,6.65,6.66Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,17.04c-.01,3.51-2.87,6.65-6.72,6.61-3.63-.03-6.59-2.95-6.58-6.69,0-3.72,3.13-6.66,6.67-6.6,3.65-.01,6.64,2.98,6.63,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,17.03c.06,3.56-2.94,6.66-6.68,6.62-3.69-.03-6.61-2.95-6.61-6.66,0-3.91,3.24-6.69,6.73-6.65,3.68,.04,6.66,3.13,6.57,6.69Z",
    style: {
      fill: "#06d7a4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs2);
export default __webpack_public_path__ + "static/media/ccs2.7daa715b8a02bbc797a86c52a67e44ae.svg";
export { ForwardRef as ReactComponent };